export default {
	Interactive: {
		DefaultName: {
			0: 'Прикольный Интерактив',
			1: 'Крутой Интерактив',
			2: 'Невероятный Интерактив',
			3: 'Незабываемый Интерактив',
			4: 'Клёвый Интерактив',
			5: 'Отличный Интерактив',
			6: 'Потрясный Интерактив',
			7: 'Великолепный Интерактив',
			8: 'Восхитительный Интерактив',
			9: 'Бомбический Интерактив',
		},
		Status: {
			Show: 'Нажми, чтобы открыть',
			Hide: 'Нажми, чтобы скрыть',
		},
	},
	Guard: {
		Disclaimer: 'Используй диалоговое окно платформы справа, чтобы выполнить действие.',
		ShareId: {
			Title: 'Нам нужно узнать друг друга ближе!',
			Message: 'Стример ввел ограничения на этот интерактив.\n\nНам нужно, чтобы ты предоставил доступ к своему ID на Twitch, тогда мы сможем проверить, что ты — тот самый зритель, который под них подходит. Не возражаешь?',
			Action: 'Предоставить',
		},
		Follow: {
			Title: 'Твоя любовь — ключ к этому интерактиву!',
			Message: 'Стример ограничил доступ к интерактиву только для зрителей которые отслеживают его канал.\n\nА ты достаточно смел, чтобы зафолловить его прямо сейчас и принять участие в веселье?',
			Action: 'Отслеживать',
		},
		Subscribe: {
			Title: 'Твоя поддержка — ключ к этому интерактиву!',
			Message: 'Стример пожелал, чтобы в этом интерактиве принимали участие только подписчики.\n\nНо если тебе прям очень хочется, то ты можешь оформить подписку прямо сейчас, ещё успеешь принять участие!',
			Action: 'Подписаться',
		}
	}
};
